export default __webpack_public_path__ + "static/media/yellow.3cbd8f77.svg";